import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import 'react-quill/dist/quill.snow.css';
import twitterText from 'twitter-text';
// import '../utils/quilMention.js';
import {
  addPandingMessage,
  addUrl,
  removePandingMessages,
  sendAmessage,
  setQuillEditortoSlice,
  updatePandingMessageUuid
} from '../../../../redux/slices/communication';
import { useTranslate } from '@tolgee/react';
import { Button } from 'react-bootstrap';
import Symbol from '../../../utils/symbol';
import { getImageUrl } from '../../../../firebase/utils';
import CustomQuillEditor from '../customQuill';
import TextAreaSettings from './textAreaSettings';
import { updatePTagsAndReturnHTML } from '../../utils/quillUtils';
import EmojiPicker from '../emojiPicker/empjiPicker';
import WhatsappTemplate from '../../../whatsappTemplateBuilder';
import ModalBody from '../../../modals/modalBody';
import { toggleTemplateModal } from '../../../../redux/slices/whatsappTemplate';
import {
  getPlatformMaxMessageLength,
  TWITTER,
  WHATSAPP
} from '../../../../config/constants';

export const TextArea = () => {
  const [templateModal, setTemplateModal] = useState(false);
  const [quillEditor, _setQuillEditor] = useState(null);
  const setQuillEditor = (editor) => {
    _setQuillEditor(editor);
    dispatch(setQuillEditortoSlice(editor));
  };
  const addPandingMessageToSlice = (message, id) => {
    if (!message) return;
    const newMessage = {
      type: 'message',
      is_sent_by_me: true,
      attachment: [],
      created: null,
      author: null,
      message_content_html: message,
      is_liked_by_me: false,
      answers: [],
      social_media_platform_user: messageSettings.is_internal_note
        ? { name, initials }
        : activeConversation?.social_media_platform_user,
      message_content: message,
      uuid: null,
      platform_created: null,
      total_reactions_count: 0,
      modified: null,
      editing_allowed: false,
      is_internal_note: messageSettings.is_internal_note,
      id
    };
    dispatch(
      addPandingMessage({ message: newMessage, uuid: activeConversation.uuid })
    );
    return newMessage;
  };
  const { initials, name } = useSelector((state) => state.userDetails);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [isReadOnly, setIsReadOnly] = useState(false);
  const [messageIsSending, setMessageIsSending] = useState(false);

  const { openTemplateModal } = useSelector(
    (state) => state.WhatsappTemplateBuilder
  );

  const successCallback = (id, uuid, conversationUuid) => {
    dispatch(updatePandingMessageUuid(conversationUuid, id, uuid));
    dispatch(removePandingMessages(conversationUuid));
    setMessageIsSending(false);
  };
  const {
    data: {
      activeConversation,
      urls,
      conversationDetails: { data }
    }
  } = useSelector((state) => state.communication);

  const { t } = useTranslate();
  const [messageSettings, setMessageSettings] = useState({
    is_internal_note: false
  });

  useEffect(() => {
    setIsReadOnly(
      !activeConversation?.rules?.can_send_answer &&
        !messageSettings?.is_internal_note
    );
  }, [activeConversation]);

  useEffect(() => {
    if (!quillEditor) return;
    if (messageSettings.is_internal_note) {
      quillEditor.root.dataset.placeholder = t(
        'communication.type_your_comment'
      );
    } else {
      if (!isReadOnly) {
        quillEditor.root.dataset.placeholder = t(
          'communication.type_your_message'
        );
      } else {
        quillEditor.root.dataset.placeholder = t(
          'communication.only_editing_possible'
        );
      }
    }
  }, [messageSettings.is_internal_note, quillEditor]);

  const [msg, setMsg] = useState('');
  const messageIsEmpty = () => {
    return msg === '<p></p>' || msg === '';
  };

  if (!activeConversation) return null;

  const platformMessageMaxLength = getPlatformMaxMessageLength(
    activeConversation?.platform,
    activeConversation?.type
  );
  const enforceMessageLimit =
    !!platformMessageMaxLength && !messageSettings.is_internal_note;
  const editorText = quillEditor ? quillEditor.getText().trim() : '';
  // Twitter counts URLs and non-ASCII characters with its own weighting, not
  // raw JS string length — matches how the composer measures Twitter posts.
  const characterCount =
    activeConversation?.platform === TWITTER
      ? twitterText.parseTweet(editorText).weightedLength
      : editorText.length;
  const messageLimitExceeded =
    enforceMessageLimit && characterCount > platformMessageMaxLength;

  const sendMessage = () => {
    if (messageLimitExceeded) return;
    setMessageIsSending(true);
    const contents = quillEditor.getContents();
    // check if content is empty
    if (!contents || contents.length === 0) return;
    if (loading) return;

    // get text from contents:
    const quillHtml = updatePTagsAndReturnHTML(quillEditor.root);
    quillEditor.disable();
    const tmpID = Date.now();
    const convUuid = activeConversation.uuid;
    setLoading(true);
    addPandingMessageToSlice(quillHtml, tmpID);

    dispatch(
      sendAmessage(
        JSON.stringify(contents),
        activeConversation.uuid,
        data?.data?.[0]?.uuid,
        messageSettings.is_internal_note,
        () => {
          setMessageIsSending(false);
        },
        (uuid) => successCallback(tmpID, uuid, convUuid)
      )
    );
    setLoading(false);
    quillEditor.setText('');
    quillEditor.enable();
  };
  const editorStyle = {
    pointerEvents:
      !activeConversation?.rules?.can_send_answer &&
      !messageSettings.is_internal_note
        ? 'none'
        : 'auto',
    height: '150px',
    resize: 'none'
  };

  const [imageUrl, setImageUrl] = useState(null);
  useEffect(() => {
    console.log('activeConversation', activeConversation);

    if (activeConversation?.social_media_platform_user?.image_file)
      if (urls?.[activeConversation?.social_media_platform_user?.image_file])
        setImageUrl(
          urls[activeConversation?.social_media_platform_user?.image_file]
        );
      else
        getImageUrl(activeConversation?.social_media_platform_user?.image_file)
          .then((url) => {
            dispatch(
              addUrl(
                activeConversation?.social_media_platform_user?.image_file,
                url
              )
            );
            setImageUrl(url);
          })
          .catch((err) => console.log(err));
  }, [activeConversation]);

  const addEmoji = (emoji) => {
    quillEditor.insertText(quillEditor.getSelection(true).index, emoji);
    quillEditor.setSelection(
      quillEditor.getSelection(true).index + (emoji.length || 2) + 1
    );
  };
  useEffect(() => {
    // add event listener for ctrl+enter
    const handleKeyDown = (e) => {
      if (e.key === 'Enter' && e.ctrlKey) {
        // check if quill is focused
        if (document.activeElement === quillEditor.root) {
          e.preventDefault();
          sendMessage();
          return;
        }
        return;
      }
      // handle keydown for cmd+enter on mac
      if (e.key === 'Enter' && e.metaKey) {
        // check if quill is focused
        if (document.activeElement === quillEditor.root) {
          e.preventDefault();
          sendMessage();
        }
      }
    };

    // remove event listener
    document.removeEventListener('keydown', handleKeyDown);
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [sendMessage]);

  return (
    <div
      className={`card m-1 ${
        messageSettings.is_internal_note ? 'bg-light-warning' : ''
      } `}
    >
      <div className="d-inline-flex m-4 flex-row align-items-center justify-content-between">
        <div className="d-inline-flex align-items-center">
          <Symbol
            img={messageSettings.is_internal_note ? null : imageUrl}
            initials={messageSettings.is_internal_note ? initials : null}
          />
          <TextAreaSettings
            setMessageSettings={setMessageSettings}
            messageSettings={messageSettings}
          />
        </div>

        {activeConversation?.platform === WHATSAPP && (
          <div>
            {' '}
            <Button
              size={'sm'}
              variant="white"
              className={'shadow'}
              onClick={() => {
                dispatch(toggleTemplateModal(true));
              }}
            >
              <span>
                <i
                  className={'fab fa-whatsapp text-success'}
                  style={{ fontSize: '20px' }}
                ></i>{' '}
              </span>
              <span>{t('communication.whatsapp.template')}</span>
            </Button>
          </div>
        )}
      </div>
      <div className="p-2">
        <CustomQuillEditor
          activeMention={messageSettings.is_internal_note}
          quillEditor={quillEditor}
          setQuillEditor={setQuillEditor}
          onEnter={() => sendMessage()}
          locationUUID={activeConversation.location_uuid}
          readOnly={isReadOnly}
          messageSettings={messageSettings}
          msg={msg}
          setMsg={setMsg}
          editorStyle={editorStyle}
        />
        <div className="d-flex justify-content-between align-items-center">
          <EmojiPicker addEmoji={addEmoji} />
          <div className="d-flex align-items-center gap-3">
            {enforceMessageLimit && (
              <small
                className={messageLimitExceeded ? 'text-danger' : 'text-muted'}
              >
                {messageLimitExceeded
                  ? t(
                      'communication.textArea.message_character_limit_exceeded',
                      { max: platformMessageMaxLength }
                    )
                  : t('communication.textArea.character_count', {
                      count: characterCount,
                      max: platformMessageMaxLength
                    })}
              </small>
            )}
            <Button
              size={'sm'}
              onClick={sendMessage}
              disabled={
                messageIsEmpty() || messageIsSending || messageLimitExceeded
              }
            >
              {t(
                messageSettings.is_internal_note
                  ? 'communication.textArea.add_note'
                  : 'communication.textArea.send'
              )}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
TextArea.propTypes = {};
